import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function FitAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "40%"}}>
                                        Quadrimestrale
                                    </th>
                                    <th scope="col" style={{width: "40%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Monosettimanale</th>
                                    <td className={"data-cell"}>194 €</td>
                                    <td className={"data-cell"}>314,50 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">Bisettimanale</th>
                                    <td className={"data-cell"}>351,50 €</td>
                                    <td className={"data-cell"}>488,50 €</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" style={{width: "25%"}}></th>
                                    <th scope="col" style={{width: "15%"}}>
                                        1 mese
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        9 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Multitessera <br/> POKER <br/>
                                    <span style={{fontSize: "12px"}}>(Solo corsi<br/> intervallo e sera)</span></th>
                                    <td className={"data-cell"}>80 €</td>
                                    <td className={"data-cell"}>216 €</td>
                                    <td className={"data-cell"}>384 €</td>
                                    <td className={"data-cell"}>504 €</td>
                                    <td className={"data-cell"}>572 €</td>
                                </tr>
                                <tr>
                                    <th scope="row">11 ingressi</th>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}>91,45 €</td>
                                    <td className={"data-cell"}></td>
                                    <td className={"data-cell"}></td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <br/>
                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FitAccordionPrezzi